var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIconUniversal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19 18.38C14.2655 18.38 18.38 14.2655 18.38 9.19C18.38 4.1145 14.2655 0 9.19 0C4.1145 0 0 4.1145 0 9.19C0 14.2655 4.1145 18.38 9.19 18.38Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19 11.028C8.85719 11.028 8.5373 10.8992 8.29734 10.6686C8.05737 10.438 7.91594 10.1235 7.90268 9.79094L7.73288 5.50323C7.72607 5.32992 7.75432 5.15701 7.81594 4.99488C7.87756 4.83274 7.97129 4.68472 8.0915 4.55968C8.21171 4.43465 8.35593 4.33517 8.51551 4.26722C8.67509 4.19926 8.84675 4.16423 9.0202 4.16422H9.3598C9.53325 4.16423 9.70491 4.19926 9.86449 4.26722C10.0241 4.33517 10.1683 4.43465 10.2885 4.55968C10.4087 4.68472 10.5024 4.83274 10.5641 4.99488C10.6257 5.15701 10.6539 5.32992 10.6471 5.50323L10.4773 9.79094C10.4641 10.1235 10.3226 10.438 10.0827 10.6686C9.8427 10.8992 9.52281 11.028 9.19 11.028Z",
    fill: "#FF951C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4762 12.9295C10.4762 12.2192 9.90037 11.6433 9.19 11.6433C8.47963 11.6433 7.90376 12.2192 7.90376 12.9295C7.90376 13.6399 8.47963 14.2158 9.19 14.2158C9.90037 14.2158 10.4762 13.6399 10.4762 12.9295Z",
    fill: "#FF951C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconUniversal);
export default __webpack_public_path__ + "static/media/WarningIconUniversal.e371cbf1d7c3f3e4ee90c5d4c4ea7a7f.svg";
export { ForwardRef as ReactComponent };